/**
 * /financeiro/contas-receber — wrapper que renderiza ContasView em modo ENTRADA.
 */
import React from "react";
import ContasView from "./ContasView";

export default function ContasAReceber() {
  return <ContasView tipo="ENTRADA" />;
}
